import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader";
import { type FC, Suspense, lazy } from "react";

const BloodPressureHistoryPage = lazy(
  () => import("./BloodPressureHistoryPage"),
);

const BloodPressureHistoryPageLazy: FC = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <BloodPressureHistoryPage />
    </Suspense>
  );
};

export default BloodPressureHistoryPageLazy;
